import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import megamenuImg from "../../assets/images/megamenu-img.png";
import logo from "../../assets/images/logo.svg";
import logoLight from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

// import images
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

//i18n
import { withTranslation } from "react-i18next";
import BotpressChat from "pages/Dashboard/BotpressChat";
import { translateText } from "../../translate";

const Header = props => {
  const [menu, setMenu] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [language, setLanguage] = useState("en");
  const [isMobile, setIsMobile] = useState(false);
  const [translatedText, setTranslatedText] = useState({
    login: "Login",
    call: "Call",
  });

  const [loggedUser, setLoggedUser] = useState(null);
  const [showHover, setShowHover] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check on initial load
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setLoggedUser(JSON.parse(user));
    }
  }, []);

  useEffect(() => {
    const addGoogleTranslateScript = () => {
      if (!document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
        const script = document.createElement("script");
        script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
      }
    };

    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement({
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL
        }, "google_translate_element");

        // Delay to ensure the dropdown is rendered
        setTimeout(() => {
          const combo = document.querySelector(".goog-te-combo");
          if (combo) {
            Array.from(combo.options).forEach((option) => {
              if (!["en", "hi", "gu"].includes(option.value)) {
                option.remove();
              }
            });
          }
        }, 1000); // adjust delay if needed
      }
    };


    addGoogleTranslateScript();

    const style = document.createElement("style");
    style.setAttribute("id", "google-translate-hide-style");
    style.innerHTML = `
      body { top: 0px !important; }
  
      .goog-te-banner-frame.skiptranslate,
      iframe.goog-te-banner-frame,
      iframe#\\:0\\.container,
      .VIpgJd-ZVi9od-ORHb-OEVmcd {
        display: none !important;
      }
      #goog-gt-tt {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
       #\\:0\\.targetLanguage .goog-te-combo {
        background-color: transparent !important;
      }

      @media only screen and (max-width: 768px) {
        #\\:0\\.targetLanguage .goog-te-combo {
          width: 121% !important;
        }
      }
      .VIpgJd-ZVi9od-ORHb-OEVmcd,
      .VIpgJd-ZVi9od-xl07Ob,
      .VIpgJd-ZVi9od-vH1Gmf,
      .goog-tooltip,
      .goog-tooltip:hover,
      .goog-tooltip * {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
  
      .goog-te-gadget-icon,
      .goog-logo-link,
      .goog-te-gadget span,
      .goog-te-gadget-simple .VIpgJd-ZVi9od-l4eHX-hSRGPd {
        display: none !important;
      }
  
      .goog-te-gadget-simple {
        background-color: transparent !important;
        border: none !important;
        padding-left: 0 !important;
      }
  
      .goog-te-menu-value {
        color: #fff !important;
      }
  
      .goog-te-gadget .goog-te-combo {
        font-size: 1rem;
        padding: 6px 12px;
        color: #fff !important;
        border: 2px solid rgba(255, 255, 255, 0.5) !important;
        border-radius: 15px !important;
        margin-left: 0 !important;
        background-color: transparent !important;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e") !important;
        background-repeat: no-repeat !important;
        background-position: right 10px center !important;
        background-size: 20px !important;
        padding-right: 32px !important;
      }

      .goog-te-gadget .goog-te-combo:hover {
        border-color: #fff !important;
      }
    
      select.goog-te-combo option {
        color: #000 !important;
        background-color: #fff !important;
      }

      select.goog-te-combo option:not([value="en"]):not([value="hi"]):not([value="gu"]) {
        display: none;
      }
  
      @media (max-width: 768px) {
        .translate-wrapper-mobile {
          margin-right: 10px;
          max-width: 120px; 
          overflow: hidden;
        }
  
        .goog-te-gadget .goog-te-combo {
          font-size: 14px !important;
          padding: 4px 6px !important;
          padding-right: 28px !important;
          width: 100%;
          border-radius: 8px !important;
          background-size: 16px !important;
          background-position: right 6px center !important;
        }
  
        .goog-te-gadget-simple {
          display: flex !important;
          justify-content: center;
          align-items: center;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      const existingStyle = document.getElementById("google-translate-hide-style");
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, []);


  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const styles = {
    actionIcons: {
      display: "flex",
      gap: "15px",
      marginRight: "26px",
      alignItems: "center"
    },
    iconLink: {
      textDecoration: "none",
      color: "#fff",
      fontSize: "30px",
    },
    translateContainer: {
      marginLeft: "-5px",
      display: "flex",
      alignItems: "center"
    },
    loginButton: {
      padding: "4px 12px",
      backgroundColor: "transparent",
      color: "#fff",
      border: "2px solid #fff",
      borderRadius: "15px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "all 0.3s ease",
      '&:hover': {
        backgroundColor: "#fff",
        color: "#000"
      }
    }
  };

  function setdesign() {
    if (props.leftMenu) {
      // Menu is open
    } else {
      // Menu is collapsed
    }
  }

  const location = useLocation();

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoLight} alt="" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="100" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLight} alt="" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="100" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
                setdesign();
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>

          <div className="d-flex" style={styles.actionIcons}>
            {/* WhatsApp */}
            <a
              href="https://wa.me/9586363303"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
              title="WhatsApp"
            >
              <i className="bx bxl-whatsapp"></i>
            </a>

            {/* Call */}
            <a href="tel:+919586363303" style={styles.iconLink} title="Call">
              <i className="bx bx-phone"></i>
            </a>

            {/* Login - Only show on desktop */}

            {/* {!isMobile && ( */}
            <div style={{ position: "relative", marginLeft: "10px" }}>
              {!loggedUser ? (
                <Link to="/login">
                  <button
                    style={{
                      padding: "4px 12px",
                      backgroundColor: "transparent",
                      color: "#fff",
                      border: "2px solid #fff",
                      borderRadius: "15px",
                      cursor: "pointer",
                      fontSize: "16px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#fff";
                      e.target.style.color = "#000";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#fff";
                    }}
                  >
                    Login
                  </button>
                </Link>
              ) : (
                <div
                  onMouseEnter={() => setShowHover(true)}
                  onMouseLeave={() => setShowHover(false)}
                  onClick={() => navigate("/profile")}

                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  {/* Profile Circle */}
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "#6f42c1",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 0 8px rgba(111,66,193,0.7)"
                    }}
                  >
                    <i
                      className="bx bx-user"
                      style={{
                        fontSize: "20px",
                        color: "#fff"
                      }}
                    ></i>
                  </div>


                  {/* Hover Welcome */}
                  {showHover && (
                    <div
                      style={{
                        position: "absolute",
                        top: "45px",
                        right: "0",
                        background: "rgba(0,0,0,0.9)",
                        color: "#fff",
                        padding: "8px 14px",
                        borderRadius: "8px",
                        whiteSpace: "nowrap",
                        fontSize: "13px",
                        zIndex: 999999,
                        boxShadow: "0 0 10px rgba(0,0,0,0.6)"
                      }}
                    >
                      Account
                      {/* Welcome, {loggedUser?.username || "User"} */}
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* )} */}

            {!isMobile && (
              <Link to="/home-page">
                <button
                  style={{
                    padding: "4px 12px",
                    backgroundColor: "transparent",
                    color: "#fff",
                    border: "2px solid #fff",
                    borderRadius: "15px",
                    cursor: "pointer",
                    fontSize: "16px",
                    marginLeft: "10px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.color = "#000";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#fff";
                  }}
                >
                  Home
                </button>
              </Link>
            )}
            {!isMobile && (
              <Link to="/about-us">
                <button
                  style={{
                    padding: "4px 12px",
                    backgroundColor: "transparent",
                    color: "#fff",
                    border: "2px solid #fff",
                    borderRadius: "15px",
                    cursor: "pointer",
                    fontSize: "16px",
                    marginLeft: "10px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.color = "#000";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#fff";
                  }}
                >
                  About Us
                </button>
              </Link>
            )}

            {/* Contact Us - Only show on desktop */}
            {!isMobile && (
              <Link to="/contact">
                <button
                  style={{
                    padding: "4px 12px",
                    backgroundColor: "transparent",
                    color: "#fff",
                    border: "2px solid #fff",
                    borderRadius: "15px",
                    cursor: "pointer",
                    fontSize: "16px",
                    marginLeft: "10px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.color = "#000";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#fff";
                  }}
                >
                  Contact Us
                </button>
              </Link>
            )}


            {/* Google Translate Widget */}
            <div style={styles.translateContainer} id="google_translate_element"></div>
          </div>
        </div>
      </header>
      {location.pathname === "/dashboard" && <BotpressChat menuState={props.leftMenu} />}
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));